import React from 'react';
import nikkiImg from '../../../assets/nikki/nikki.png';

const WelcomeHeroCard = ({ data }) => (
  <div
    className="relative overflow-hidden rounded-sm border border-primary/20 bg-gradient-to-br from-primary/10 via-zinc-900/40 to-zinc-900/20 p-6"
    data-testid="card-welcome-hero"
  >
    <div className="absolute top-0 right-0 w-24 h-24 bg-primary/10 rounded-full blur-3xl" />
    <div className="relative flex items-start gap-4">
      <img
        src={nikkiImg}
        alt="Nikki"
        title="Nikki"
        className="w-16 h-16 rounded-full border-2 border-primary/40 object-cover flex-shrink-0 shadow-[0_0_24px_rgba(204,255,0,0.15)]"
        data-testid="welcome-nikki-avatar"
      />
      <div>
        <h2 className="text-2xl font-secondary font-bold tracking-tight" data-testid="welcome-headline">
          {data?.headline || "Hi, I'm Nikki"}
        </h2>
        {data?.tagline && <p className="text-zinc-400 mt-2 leading-relaxed">{data.tagline}</p>}
      </div>
    </div>
  </div>
);

export default WelcomeHeroCard;
